import styled from "styled-components"

export const BlogBody = styled.p`
    font-size: 1.2em;
    word-wrap: break-word;

    h1{
        font-size: 24px;
        margin-top: 0;
    }
`

export const BlogTitle = styled.p`
    font-size: 2em;
    word-wrap: break-word;
    text-transform: capitalize;
    margin-bottom: 5px;
`

export const ReadTime = styled.div`
    margin-bottom: 5px;
`

export const BlogWrapper = styled.div`
    width: min(900px, max(80%, 350px));
    margin: auto;
    padding: 50px 0;
    display: flex;
    flex-direction: column;
    gap: 50px;
`

export const BlogPageWrapper = styled.div`
    width: min(700px, max(70%, 350px));
    margin: 100px auto 50px;

    h1 {
        font-size: 2rem;
    }

    font-size: 18px;

    img{
        display: block;
        width: 75%;
        margin: auto;
    }
`

export const BlogSectionSpacer = styled.div`
  height: 1px; /* Adjust thickness */
  width: 100%; /* Adjust height */
  background-color: rgb(12, 235, 179); /* Set color */
`

export const BlogImage = styled.img`
    width: 100% !important;
    border-radius: 15px;
`